import moment from "moment";
import { useOrderFlow } from "../OrderFlowProvider/OrderFlowContext";
import { ModuleTypes } from "../OrderFlowProvider/OrderFlowTypes";
import { FormatArrayWithCommas } from "../utils/orderFlowUtils";
/**
 * Handles logic for checking what meals are missing recipe selections
 * @returns missingRecipeSelections - boolean
 * @returns missingMealsMessages - Array<string>
 */
export const useRecipeSelectionWarning = () => {
    var _a, _b, _c;
    const { store } = useOrderFlow();
    const modulesForCurrentPage = store.model.Flow.FlowModules.filter((flow) => flow.Page === store.cart.currentPage);
    const doesPageHaveRecipeWarningModule = Boolean(modulesForCurrentPage.find((module) => module.Module.ModuleType === ModuleTypes.RECIPE_SELECTION_WARNING));
    const recipeModule = store.model.Flow.FlowModules.find((module) => module.Module.ModuleType === ModuleTypes.RECIPE);
    const programMeals = (_a = recipeModule === null || recipeModule === void 0 ? void 0 : recipeModule.ModuleConfig) === null || _a === void 0 ? void 0 : _a.ProgramMeals;
    let missingMeals = [];
    (_c = (_b = store.cart) === null || _b === void 0 ? void 0 : _b.meals) === null || _c === void 0 ? void 0 : _c.map((meal) => {
        if (programMeals && programMeals.includes(meal.ProgramMealId)) {
            const doesDayHaveRecipes = store.model.Recipes &&
                store.model.Recipes.some((recipe) => recipe.Assignments.find((assignment) => moment(assignment.Date).isSame(meal.MealDate)));
            const doesMealHaveRecipes = store.model.Recipes &&
                store.model.Recipes.some((recipe) => recipe.Assignments.find((assignment) => moment(assignment.Date).isSame(meal.MealDate) && assignment.ProgramMealId === meal.ProgramMealId));
            if (meal.RecipeAssignments && doesDayHaveRecipes && doesMealHaveRecipes) {
                let recipeAssignmentQuantity = 0;
                meal.RecipeAssignments.map((assignment) => (recipeAssignmentQuantity += assignment.Quantity));
                if (recipeAssignmentQuantity < meal.Quantity) {
                    let index = missingMeals.findIndex((obj) => obj.date === moment(meal.MealDate).format("ddd MMM Do"));
                    if (index == -1) {
                        missingMeals.push({ date: moment(meal.MealDate).format("ddd MMM Do"), meals: [meal.ProgramMealName] });
                    }
                    else {
                        missingMeals[index].meals.push(meal.ProgramMealName);
                    }
                }
            }
            else if (doesDayHaveRecipes && doesMealHaveRecipes) {
                const index = missingMeals.findIndex((obj) => obj.date === moment(meal.MealDate).format("ddd MMM Do"));
                if (index == -1) {
                    missingMeals.push({ date: moment(meal.MealDate).format("ddd MMM Do"), meals: [meal.ProgramMealName] });
                }
                else {
                    missingMeals[index].meals.push(meal.ProgramMealName);
                }
            }
        }
    });
    let missingMealsMessages = [];
    if (missingMeals.length > 0 && Boolean(store.model.recipeSelectionMissingMealsMessage)) {
        missingMeals.map((missingMeal) => {
            missingMealsMessages.push(store.model.recipeSelectionMissingMealsMessage
                .replace("{mealType}", FormatArrayWithCommas(missingMeal.meals))
                .replace("{date}", missingMeal.date));
        });
    }
    const missingRecipeSelections = doesPageHaveRecipeWarningModule && missingMeals.length > 0;
    return {
        missingRecipeSelections,
        missingMealsMessages,
    };
};
